<template>
  <div class="coupon-wrap">
    <div class="coupon-back" @click="$emit('close')">
      <div class="button"></div>
    </div>

    <div class="coupon-form">
      <div class="coupon-line">
        <div class="coupon-input-wrap">
          <input
            type="tel"
            class="coupon-input coupon-Authcode"
            v-model="formData.tel"
            placeholder="请输入您的手机号码"
            @keyup="onlyNumber('tel', 11)"
            @change="validateContactNumber(formData.tel)"
          />
          <div
            :class="authcode"
            :disabled="sendButtonType"
            @click="getSecurityCode"
          >{{sendButtonMsg}}</div>
        </div>
      </div>
      <div class="coupon-line">
        <div class="coupon-input-wrap">
          <input
            type="text"
            class="coupon-input"
            v-model="formData.verificationCode"
            placeholder="请输入验证码"
            @change="validateVerificationCode(formData.verificationCode)"
            @keyup="onlyNumber('verificationCode', 4)"
          />
        </div>
      </div>
    </div>
    <div class="submit-footer">
      <div class="butt-check" @click="submitApply" :disable="submitButtonType">立即领取</div>
    </div>
    <el-dialog
      :visible="isSubmitSuccess"
      :show-close="false"
      :modal="true"
      append-to-body
      top="37.5vh"
    >
      <div class="coupon-success-popup">
        <div class="coupon-close" @click="isSubmitSuccess=false"></div>
        <p class="coupon-success-p1">抵扣券领取成功</p>
        <p class="coupon-success-p2">抵扣券码：{{couponCode}}</p>
        <div class="successs-footer">已发送至尾号为{{telFour}}的手机上，请注意查收！</div>
      </div>
    </el-dialog>
  </div>
</template>

<script >
import { getPrizeCode, sendVerificationCode } from "@/api";
import md5 from "js-md5";
export default {
  name: "complaint",
  data() {
    return {
      formData: {
        tel: "",
        verificationCode: ""
      },
      outerVisible: false,
      innerVisible: false,
      sendButtonType: false,
      submitButtonType: false,
      submitting: false,
      waitTime: 30,
      sendButtonMsg: "获取验证码",
      authcode: "authcode-wraps",
      couponCode: "",
      telFour: "",
      isSubmitSuccess: false
    };
  },
  methods: {
    //立即领取
    submitApply() {
      if (this.submitting) return; // 防止连续点击
      let params = Object.assign({}, this.formData);
      this.submitting = true;
      getPrizeCode(params)
        .then(res => {
          // 调用接口
          if (res.code === 200) {
            this.couponCode = res.result.data;
            this.isSubmitSuccess = true;
            this.telFour = this.formData.tel.substr(
              this.formData.tel.length - 4
            );
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    // 验证手机号
    validateContactNumber(val) {
      if (!val) {
        this.sendButtonType = true;
        this.authcode = "authcode-wraps";
        return;
      }
      let phoneReg = /^(1[3-9]{1})\d{9}$/;
      if (!phoneReg.test(val)) {
        this.sendButtonType = true;
        this.authcode = "authcode-wraps";
        return;
      }
      this.sendButtonType = false;
      this.authcode = "authcode-click";
    },

    //验证验证码
    validateVerificationCode(val) {
      if (!val) {
        this.submitButtonType = true;
        return;
      }
      this.submitButtonType = false;
    },

    onlyNumber(key, len) {
      if (key == "tel") {
      this.authcode = "authcode-click";
      }
      let val = this.formData[key];
      if (val.length > len) {
        this.formData[key] = val.substring(0, len);
      }
      if (/[^\d]/g.test(val)) {
        this.formData[key] = val.replace(/[^\d]/g, "");
      }
    },
    //获取手机验证码
    getSecurityCode() {
      //点击后按钮无效
      this.authcode = "authcode-wraps";
      var timestamp = new Date().getTime().toString(),
        secret = "c3ceea8123d5417ab02edb9d8c7e331d",
        sign = md5(secret + timestamp + secret);
      let param = {
        tel: this.formData.tel,
        signCode: sign,
        timestamp: timestamp
      };
      if (!this.sendButtonType) {
        sendVerificationCode(param).then(
          res => {
            if (res.code == 200) {
              let time = this.waitTime;
              let clock = setInterval(() => {
                time--;
                if (time < 0) {
                  clearInterval(clock);
                  this.sendButtonMsg = "发送验证码";
                  this.sendButtonType = false;
                  this.authcode = "authcode-click";
                  return;
                }
                this.sendButtonMsg = time + "秒";
              }, 1000);
            }
          },
          () => {
            this.sendButtonType = false;
            this.authcode = "authcode-click";
          }
        );
      }
      this.sendButtonType = true;
    }
  }
};
</script>

<style lang="less" scope>
// @deep: ~'>>>';
.coupon-wrap {
  position: relative;
  width: 626px;
  margin:auto;
  height: 630px;
  background-image: url("../assets/coupon.png");
  background-size: 100% 100%;
}

.coupon-back {
  display: inline-block;
  text-align: center;
  .button {
    position: absolute;
    top: -33px;
    background-image: url("../assets/couponClose.png");
    width: 30px;
    height: 30px;
    background-size: 100% !important;
    cursor: pointer;
  }
}
.coupon-form {
  margin-top: 340px;
}
.coupon-line {
  width: 400px;
  margin: 0 auto;
  margin-bottom: 35px;
}

.coupon-input-wrap {
  position: relative;
  height: 36px;
  margin-bottom: 10px;
}
.coupon-input {
  box-sizing: border-box;
  width: 100%;
  height: 44px;
  padding-left: 15px;
  font-size: 18px;
  border-radius: 4px;
  outline: none;
  color: #666;
}

.coupon-Authcode {
  float: left;
  vertical-align: top;
  width: 70%;
}

.authcode-wraps {
  display: inline-block;
  vertical-align: top;
  color: rgba(192, 42, 4, 0.3);
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  line-height: 44px;
  box-sizing: border-box;
  width: 30%;
  height: 44px;
  background-color: #ffd081;
  border-radius: 4px;
}
.authcode-click {
  display: inline-block;
  vertical-align: top;
  color: rgba(192, 42, 4, 1);
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  line-height: 44px;
  box-sizing: border-box;
  width: 30%;
  height: 44px;
  background-color: #ffd081;
  border-radius: 4px;
}
.coupon-input:focus {
  border-color: rgba(192, 42, 4, 0.5);
  z-index: 1;
}
.butt-check {
  display: inline-block;
  color: rgba(192, 42, 4, 0.41);
  font-size: 20px;
  text-align: center;
  line-height: 60px;
  cursor: pointer;
  width: 255px;
  height: 60px;
  background: linear-gradient(
    360deg,
    rgba(255, 254, 196, 1) 0%,
    rgba(255, 248, 230, 1) 100%,
    rgba(255, 248, 230, 1) 100%
  );
  box-shadow: 0px 5px 0px rgba(227, 190, 180, 0.41);
  border-radius: 8px;
}
.butt-check:hover {
  color: rgba(192, 42, 4, 1);
}

.submit-footer {
  margin-top: 56px;
}

.coupon-close {
  position: absolute;
  top: 5%;
  left: 93%;
  width: 17px;
  height: 17px;
  background-image: url("../assets/platform/close.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}

.coupon-success-wrap {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.coupon-success-popup {
  position: absolute;
  top: 49.5%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 402px;
  height: 175px;
  border-radius: 4px;
  background-color: #fff;
  text-align: center;
  box-shadow: 1px 1px 6px #999;
}
.successs-footer {
  position: absolute;
  height: 55px;
  line-height: 55px;
  top: 95%;
  width: 402px;
  border-radius: 4px;
  text-align: center;
  height: 55px;
  background: rgba(239, 239, 239, 1);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  font-size: 15px;
  color: rgba(101, 101, 101, 1);
}
.coupon-success-p1 {
  margin: 52px auto 20px auto;
  font-size: 34px;
  line-height: 40px;
  color: rgba(243, 111, 111, 1);
}
.coupon-success-p2 {
  font-size: 25px;
  line-height: 40px;
  color: rgba(101, 101, 101, 1);
}

.el-dialog__wrapper {
  /deep/.el-dialog {
    // width: 100%;
    margin: 0 auto;
    background: rgba(0, 0, 0, 0);
    border-radius: 0px;
    -webkit-box-shadow: 0 0px 0px rgba(0, 0, 0, 0);
    box-shadow: 0 0px 0px rgba(0, 0, 0, 0);
  }
  /deep/.el-dialog__header {
    padding: 0px 0px 0px;
  }
  /deep/.el-dialog__body {
    padding: 0px 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/coupon.vue